import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { isEmpty, isArray } from 'lodash';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { get } from 'lodash';

import { RadioGroup } from '~/components/Form';
import { ConfirmationDialogRaw } from '~/components';
import { Spinner } from '~/components';

import { t } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  const [modoIntegracaoSIAD, setModoIntegracaoSIAD] = useState('');
  const [atualizaStatusSIAD, setAtualizaStatusSIAD] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('INTEGRAÇÃO SIAD');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();

  const execHandleConfirmar = (param) => {
    setParamSubmit(param);
    //customizando a mensagem 
    //param.chkAlterarHodVeiculo === true ? 1 : 0
    if (modoIntegracaoSIAD === '1') {
      setMensagemConfirmationDialogRaw(`Deseja Habilitar a Integração dos Postos?`);
    } else {
      setMensagemConfirmationDialogRaw(`Deseja Desabilitar a Integração dos Postos`);
    }
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (newValue) => {
    //console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        //handleSubmitConfirmar();
        setIsLoading(true);
        handleSubmit(paramSubmit)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }

  };

  async function handleSubmitPegunta(param) {
    await setIsLoading(true);
    await execHandleConfirmar(param);
  }




  async function handleSubmit(param) {
    try {

      const objSend = {
        codPosto: '',
        status: modoIntegracaoSIAD, //param.rgpIntegracaoSiad,
      };

      await api.put('alterarconfigintegracaopostosiad', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await setIsLoading(false);

      await close();
    } catch (err) {
      await setIsLoading(false);
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  async function getConfigSistema() {
    try {
      //setIsLoading(true);
      const response = await api.get(`/configsistema`);
      const statusRetorno = get(
        response,
        'data.cosi_consul_libera_abast_siad',
        ''
      );
      //await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      if (response && !isEmpty(response.data)) {
        if (String(response.data.cosi_consul_libera_abast_siad) === '1') {
          setModoIntegracaoSIAD('1');
        } else {
          setModoIntegracaoSIAD('0');
        }
      }
    } catch (err) {
      //setIsLoading(false);
      setModoIntegracaoSIAD('0');
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getConfigSistema();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [atualizaStatusSIAD]);

  async function handleUpdateBaseSiad() {
    await setAtualizaStatusSIAD(!atualizaStatusSIAD);
  }

  useEffect(() => {
    reference.current.setData(data);
    handleUpdateBaseSiad();
  }, []);

  return (
    <>

      <> {/* <> Para confirmação do form */}
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
        />
      </> {/* <> Para confirmação do form */}

      {isLoading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (

          <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmitPegunta}>
            <RadioGroup
              name="rgpIntegracaoSiad"
              label={`Selecione uma opção:`}
              value={modoIntegracaoSIAD}
              onChange={(event, newValue) => {
                setModoIntegracaoSIAD(newValue);
              }}
              options={[
                {
                  label: `Ativo`,
                  value: '1',
                },
                {
                  label: `Desativado`,
                  value: '0',
                },
              ]}
              //disabled={typeUser === 'U'}
              serialize={(value) => String(value)}
            />
          </ContainerForm>

        )}
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
